import React from "react";
import { Link } from "react-router-dom";
import FormWizard from "react-form-wizard-component";
import 'react-form-wizard-component/dist/style.css';

class CreatePosition extends React.Component {

    render() {
        const handleComplete = () => {
            // Handle form completion logic here
        };
        const tabChanged = ({
            prevIndex,
            nextIndex
        }) => {
        };

        return (
          <div>

                <div id="circular-menu" className="circular-menu">

                    <a className="floating-btn" >
                        <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
                        <i aria-hidden="true" className="fa fa-times"></i>
                    </a>

                    <div className="items-wrapper">
                        <div className="menu-item is-flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                        </div>
                        <a className="menu-item is-flex right-panel-trigger" data-panel="languages-panel">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                        </a>
                        <Link to="" className="menu-item is-flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                        </Link>
                        <a className="menu-item is-flex right-panel-trigger" data-panel="activity-panel">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                        </a>
                    </div>

                </div>
                {/* <!-- row --> */}
                <div className="container-fluid">

                    <div className="row">
                        <div className="col-md-8 shrink-w">
                            <div className="form-head d-flex flex-wrap align-items-center mb-3">
                                <div className="me-auto">
                                    <h2 className="font-w600 mb-0">Add Job</h2>
                                    <p className="text-light">Lorem ipsum dolor sit amet</p>
                                </div>
                                <div className="rightside-tabs">
                                    <Link to="RecruitmentDashboard"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-arrow-left-short" viewBox="0 0
 16 16"><path fillRule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.7
 07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
 .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"></path></svg></Link>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xl-8">
                                    <div className="col-xl-12">
                                        <div className="supp-req">

                                            <div className="addcourseform">
                                                <form>
                                                    <span className="tagtitle">Role</span>
                                                    <div className="row">
                                                        <div className="mb-4 col-md-12">
                                                            <input type="text" cols="1" rows="4" className="form-control bg-chng" placeholder="Title" />
                                                        </div>
                                                        <div className="mb-4 col-md-12">
                                                        <label className="form-label">Job Description</label>
                                                        <div className="cover-form">
                                                            <textarea className="form-control h-auto" rows="6" cols="1" placeholder="Mention Job Description"></textarea></div>
                                                    </div>
                                                    <div className="mb-4 col-md-12">
                                                        <label className="form-label">Job Responsibilities</label>
                                                        <div className="cover-form">
                                                            <textarea className="form-control h-auto" rows="6" cols="1" placeholder="Mention Job Responsibilities"></textarea></div>
                                                    </div>
                                                     <div className="mb-4 col-md-6">
                                                            <label className="form-label">Minimum Exp. (Yrs.)</label>
                                                            <div className="cover-form">
                                                                <div><i className="fa fa-money" aria-hidden="true"></i></div>
                                                                <input type="email" className="form-control" /></div>
                                                        </div>
                                                        <div className="mb-4 col-md-6">
                                                            <label className="form-label">Maximum Exp (Yrs.)</label>
                                                            <div className="cover-form">
                                                                <div><i className="fa fa-money" aria-hidden="true"></i></div>
                                                                <input type="number" className="form-control" /></div>
                                                        </div>
                                                       
                                                        <div className="mb-4 col-md-6">
                                                            <label className="form-label">Minimum Salary</label>
                                                            <div className="cover-form">
                                                                <div><i className="fa fa-money" aria-hidden="true"></i></div>
                                                                <input type="number" className="form-control" /></div>
                                                        </div>
                                                        <div className="mb-4 col-md-6">
                                                            <label className="form-label">Maximum Salary</label>
                                                            <div className="cover-form">
                                                                <div><i className="fa fa-money" aria-hidden="true"></i></div>
                                                                <input type="email" className="form-control" /></div>
                                                        </div>
                                                        <div className="mb-4 col-md-6">
                                                            <label className="form-label">Priority</label>
                                                            <div className="cover-form">
                                                                <div><i className="fa fa-user-o" aria-hidden="true"></i></div>
                                                                <select id="inputState" className="default-select form-control wide">
                                                                    <option selected="">Choose...</option>
                                                                    <option>Low</option>
                                                                    <option>High</option>
                                                                    <option>Medium</option>
                                                                </select></div>
                                                        </div>
                                                        <div className="mb-4 col-md-6">
                                                            <label className="form-label">Select Location</label>
                                                            <div className="cover-form">
                                                                <div><i className="fa fa-user-o" aria-hidden="true"></i></div>
                                                                <select id="inputState" className="default-select form-control wide">
                                                                    <option selected="">Choose...</option>
                                                                    <option>Delhi</option>
                                                                    <option>Noida</option>
                                                                </select></div>
                                                        </div>
                                                        <div className="mb-4 col-md-12">
                                                            <label className="form-label">Stake Holder Name</label>
                                                            <div className="cover-form">
                                                                <div><i className="fa fa-user-o" aria-hidden="true"></i></div>
                                                                <input type="email" className="form-control" /></div>
                                                        </div>

                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4">
                                    <div className="row addcourseform">
                                        <div className="col-xl-12">
                                            <div className="mb-4 col-md-12">
                                                        <label className="form-label">Status</label>
                                                        <div className="check-leveloption">
                                                            <div className="inner">
                                                                <input type="radio" id="one" name="fav_language" value="ONE" />
                                                                <span>Open</span>
                                                            </div>
                                                            <div className="inner">
                                                                <input type="radio" id="two" name="fav_language" value="TWO" />
                                                                <span>Close</span>
                                                            </div>
                                                           
                                                        </div>
                                                    </div>
                                            <div className="mb-2 col-md-12">
                                                <label className="form-label">Skills Required</label>
                                                <div className="cover-form">
                                                    <div><i className="fa fa-bookmark-o" aria-hidden="true"></i></div>
                                                    <select id="inputState" className="default-select form-control wide">
                                                        <option selected="">Choose...</option>
                                                        <option>Facebook</option>
                                                        <option>Instagram</option>
                                                        <option>Youtube</option>
                                                    </select></div>
                                            </div>
                                            <div className="divider mt-4">
                                                <hr /><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-square-dotted" viewBox="0 0 16 16">
                                                    <path d="M2.5 0q-.25 0-.487.048l.194.98A1.5 1.5 0 0 1 2.5 1h.458V0zm2.292 0h-.917v1h.917zm1.833 0h-.917v1h.917zm1.833 0h-.916v1h.916zm1.834 0h-.917v1h.917zm1.833 0h-.917v1h.917zM13.5 0h-.458v1h.458q.151 0 .293.029l.194-.981A2.5 2.5 0 0 0 13.5 0m2.079 1.11a2.5 2.5 0 0 0-.69-.689l-.556.831q.248.167.415.415l.83-.556zM1.11.421a2.5 2.5 0 0 0-.689.69l.831.556c.11-.164.251-.305.415-.415zM16 2.5q0-.25-.048-.487l-.98.194q.027.141.028.293v.458h1zM.048 2.013A2.5 2.5 0 0 0 0 2.5v.458h1V2.5q0-.151.029-.293zM0 3.875v.917h1v-.917zm16 .917v-.917h-1v.917zM0 5.708v.917h1v-.917zm16 .917v-.917h-1v.917zM0 7.542v.916h1v-.916zm15 .916h1v-.916h-1zM0 9.375v.917h1v-.917zm16 .917v-.917h-1v.917zm-16 .916v.917h1v-.917zm16 .917v-.917h-1v.917zm-16 .917v.458q0 .25.048.487l.98-.194A1.5 1.5 0 0 1 1 13.5v-.458zm16 .458v-.458h-1v.458q0 .151-.029.293l.981.194Q16 13.75 16 13.5M.421 14.89c.183.272.417.506.69.689l.556-.831a1.5 1.5 0 0 1-.415-.415zm14.469.689c.272-.183.506-.417.689-.69l-.831-.556c-.11.164-.251.305-.415.415l.556.83zm-12.877.373Q2.25 16 2.5 16h.458v-1H2.5q-.151 0-.293-.029zM13.5 16q.25 0 .487-.048l-.194-.98A1.5 1.5 0 0 1 13.5 15h-.458v1zm-9.625 0h.917v-1h-.917zm1.833 0h.917v-1h-.917zm1.834-1v1h.916v-1zm1.833 1h.917v-1h-.917zm1.833 0h.917v-1h-.917zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3z" />
                                                </svg></div>
                                            <div className="mb-2 col-md-12">
                                            <label className="form-label">Added Skill</label>
                                            <ul className="added-socialmedia">
                                                <li>Powerpoint<i className="fa fa-trash-o"></i></li>
                                                <li>BootStrap<i className="fa fa-trash-o"></i></li>
                                            </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="btns-grp">
                                        <button className="savebtn-click">Save Job</button>
                                        <button className="publish-click">Publish Job</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="modal fade" id="contact-manager">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title m-auto">Contact Your Reporting Manager htmlFor Any Leave Clarifications</h5>

                            </div>
                            <div className="modal-body text-center">
                                <form>
                                    <div className="form-group text-left">
                                        <label>Repoting Manager</label>
                                        <select className="default-select form-control wide mb-3">
                                            <option selected disabled>Select reporting manager</option>
                                            <option>Arun Mishra</option>
                                            <option>Pragya Tiwari</option>
                                            <option>Alisha Goyal</option>
                                        </select></div>
                                    <div className="form-group text-left">
                                        <label className="mt-3">Reason</label>
                                        <textarea rows="4" cols="1" className="form-control"></textarea></div>

                                </form>


                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger light" data-bs-dismiss="modal">Decline</button>
                                <button type="button" className="btn btn-primary">Accept</button>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        )
    }
}
export default CreatePosition